import React from 'react';
import Modal from '../shared/Modal';
import withSplashMessage from '../splashMessage/withSplashMessage';

class ServiceSendDetailsMessageTypeModal extends React.Component {

  render() {
    if (!this.props.isOpen) return '';
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.closeModal}>
        <div className="admin-wrapper">
            <h2 className="h3 cms__section-head">Invite Type:</h2>
            <div className="form__row">
              <div className="form__row-item--half">
                <div
                  className="btn btn--solid-blue btn--full-width"
                  onClick={() => this.props.openInviteModal(false)}
                >
                  Send Email
                </div>
              </div>
              <div className="form__row-item--half">
                <div
                  className="btn btn--solid-blue btn--full-width"
                  onClick={() => this.props.openInviteModal(true)}
                >
                  Send SMS
                </div>
              </div>
            </div>
        </div>
      </Modal>
    );
  }
}

export default withSplashMessage(ServiceSendDetailsMessageTypeModal);



// WEBPACK FOOTER //
// ./src/components/service/ServiceSendDetailsMessageTypeModal.js